// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__posvs","content":"PageHeader_content__zCm6g"};